module.exports = {"620102001":"酒泉路街道","620102002":"张掖路街道","620102003":"雁南街道","620102004":"临夏路街道","620102005":"雁北街道","620102006":"五泉街道","620102007":"白银路街道","620102008":"皋兰路街道","620102009":"广武门街道","620102010":"伏龙坪街道","620102011":"靖远路街道","620102012":"草场街街道","620102013":"火车站街道","620102014":"拱星墩街道","620102015":"东岗街道","620102016":"团结新村街道","620102017":"东岗西路街道","620102018":"铁路东村街道","620102019":"铁路西村街道","620102020":"渭源路街道","620102021":"盐场路街道","620102022":"嘉峪关路街道","620102023":"焦家湾街道","620102024":"青白石街道","620102025":"雁园街道","620102400":"高新区","620102402":"甘肃农垦集团","620102403":"甘肃监狱企业集团公司"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620102.json
// module id = 3029
// module chunks = 0